import React from "react"
import { useSelector } from "react-redux"
import Select from 'react-select'
import { RootState } from "../../redux-stores/store"

const MAX_TRIGGERS = 3;

interface TriggersSelectionProps {
    triggers: string[],
    onChange: (triggers: string[]) => void,
    isDisabled: boolean
}

interface Option { label: string, value: string }

const TriggersSelection: React.FC<TriggersSelectionProps> = ({ triggers = [], onChange, isDisabled }) => {
    const selectedSocialAccount = useSelector((state: RootState) => state.dmAutomationsList.selectedSocialAccount);
    const triggers_list = useSelector((state: RootState) => state.dmAutomationsList.automations[selectedSocialAccount?.social_account?.uuid!]?.trigger_list ?? []);

    const getOptions = () => {
        let options: Option[] = [];

        for (let trigger of triggers_list) {
            options.push({ label: trigger, value: trigger });
        }

        return options;
    }

    const getSelectedTriggers = () => {
        let selectedOptions: Option[] = [];
        for (let trigger of triggers) {
            selectedOptions.push({ label: trigger, value: trigger });
        }

        return selectedOptions;
    }

    const handleChange = (selectedOptions: any) => {
        if (Array.isArray(selectedOptions)) {
            onChange(selectedOptions.map((opt) => opt.value));
        }
    }

    return (
        <Select menuPlacement="bottom" placeholder="Add keywords" isDisabled={isDisabled} options={getOptions()} isMulti value={getSelectedTriggers()} isOptionDisabled={() => getSelectedTriggers().length >= MAX_TRIGGERS} onChange={handleChange} />
    )
}

export default TriggersSelection